import React, { useEffect, useRef, useState } from "react";

import "./Aside_V2.scss";

import { FaBars } from "react-icons/fa";
import { getBankList, sendMoneyRequest, settlementApi, verifyAccount } from "../../utils/api";
import {
  isAlphabet,
  isEmpty,
  isNumber,
  numberToWords,
} from "../../utils/common";
import Spinner from "../spinner/Spinner";
import { AlertWrapper } from "../Modal/style";
import Receipt from "../Receipt/Receipt";
import Select from "react-select"

const initialFormData = {
  accountNumber: "",
  beneficiaryID: "",
  beneficiaryName: "",
  ifscCode: "",
  merchantId: "",
  mobileNumber: "",
  remittanceAmount: "",
  remarks: "",
  latitude: "24.034401",
  longitude: "74.780403",
  bankName: "",
  route: "IMPS",
  mode: "DIOSM",
  bankId: "",

};
const initialFormDataErr = {
  accountNumber: "",
  beneficiaryID: "",
  beneficiaryName: "",
  ifscCode: "",
  merchantId: "",
  mobileNumber: "",
  remittanceAmount: "",
  mode: "",
  bankName: ""
};
function AsideLeft_V2({ data = [], close = () => { }, refresh = () => { }, payoutData = {}, userName, type = "Payout", settlementData }) {
  const [fromData, setFromData] = useState({ ...initialFormData });
  const [fromDataErr, setFromDataErr] = useState(initialFormDataErr);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [verify, setVerify] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [loding, setLoding] = useState(false);
  const [cls, setCls] = useState("");
  const [message, setMessage] = useState({});
  const [verifyResp, setVerifyResp] = useState({});
  const [responceData, setResponceData] = useState({});
  const [commisionType, setCommisionType] = useState("R");
  const [commission, setCommission] = useState(0);
  const [calData, setCalData] = useState(null);

    const beneficiaryRef = useRef(null);
const accountRef = useRef(null);
const ifscRef = useRef(null);
const amountRef = useRef(null);

  const closeBox = () => {
    setCls(" active wait");
    setTimeout(() => {
      close(false);
    }, 300);
  };

  useEffect(() => {
    getBankList().then((resp) => {
      setBankList(resp?.data?.data);
    });
    setTimeout(() => {
      setCls("active");
    });
  }, []);

  let regifsc = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);

  const ckeckError = () => {

    let error = {};

    if (isEmpty(fromData.mode)) {
      error = { ...error, mode: "Please select debit account" };
    }

    if (isEmpty(fromData.beneficiaryName)) {
      error = { ...error, beneficiaryName: "Please enter beneficiary name" };
    }
    if (isEmpty(fromData.accountNumber)) {
      error = { ...error, accountNumber: "Please enter account number" };
    }
    // if (isEmpty(fromData.bankName)) {
    //   error = { ...error, bankName: "Please select bank" };
    // }
    if (isEmpty(fromData.ifscCode)) {
      error = { ...error, ifscCode: "Please enter ifsc" };
    } else if (regifsc.test(fromData.ifscCode) != true) {
      error = { ...error, ifscCode: "Please enter the valid format of ifsc" };
    }
    if (isEmpty(fromData.remittanceAmount)) {
      error = { ...error, remittanceAmount: "Please enter amount" };
    }
    return error
  }
  const onSubmit = () => {
    const error = ckeckError();
    
    setFromDataErr({ ...fromDataErr, ...error });

    if (isEmpty(error)) {
      const params = {
        name: fromData.beneficiaryName,
        accountNumber: fromData.accountNumber,
        bankIfsc: fromData.ifscCode,
        transferMode: fromData.route,
        transferAmount: fromData.remittanceAmount,
        latitude: "24.034401",
        longitude: "74.780403",
        remarks: isEmpty(fromData.remarks) ? " " : fromData.remarks,
        txnMode: "PAY_OUT",
        txnFlag: fromData.mode,
        clientCode: fromData.mode,
      };
      setLoding(true);

      if (type === "settlement") {
        params.refTxnId = settlementData?.transactionId;
        params.commission = calData?.commissionAmount;
         settlementApi(params).then((response) => {
haldleResponce(response)
      }).catch(()=>{
        setLoding(false);
        setMessage({ msg: "Something went wrong", type: "error" });
      })
      }else{
 sendMoneyRequest(params).then((response) => {
haldleResponce(response)
      }).catch(()=>{
         setLoding(false);
             setMessage({ msg: "Something went wrong", type: "error" });
      })
      }

     
    }else{
      scrollToError();
    }
  };
const haldleResponce = (response) =>{
       
 setLoding(false);
        if (response?.data?.success) {
          setResponceData(response?.data?.data);
          setFromData({ ...initialFormData });
          refresh("refresh");
        } else {
          let msg = "";
          if (response?.data?.errorCodeList.length > 0) {
            msg = response?.data?.errorCodeList[0];
          } else {
            msg = response?.data?.msg;
          }
          setMessage({ msg: msg, type: "error" });
        }
}
  function onchangeHandler(e) {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "beneficiaryName") {
      if (!isAlphabet(value) && !isEmpty(value)) {
        return;
      }
    }
    if (name === "remittanceAmount") {
      if (!isNumber(value) && !isEmpty(value)) return;
      if (value == "0") return;
    }

    if (name === "remittanceAmount" && value > 500000) {
      return;
    }

    if (name === "ifscCode") {
      let upperCase = value.toUpperCase();
      setFromData({ ...fromData, [name]: upperCase });
    }

    if (name === "bankName") {
      const bank = bankList.find(item => item.bankName === value);
      setFromData({ ...fromData, [name]: value, bankId: bank?.bankId });
    } else {
      setFromData({ ...fromData, [name]: value });
    }

    setFromDataErr({ ...fromDataErr, [name]: "" });
  }

  const routeHandler = (routeType) => {
    setFromData({ ...fromData, route: routeType });
    setFromDataErr({ ...fromDataErr, route: "" });
  };

  const onCloseModal = () => {
    setResponceData({});
    closeBox()
  };

  useEffect(() => {
    setFromData({
      accountNumber: payoutData?.accountNumber || "",
      beneficiaryID: "",
      beneficiaryName: payoutData?.accountHolderName || "",
      ifscCode: payoutData?.accountIfscCode || "",
      merchantId: "",
      mobileNumber: "",
      remittanceAmount: "",
      mode: "",
      remarks: "",
      latitude: "24.034401",
      longitude: "74.780403",
      mode: "DIOSM",
      route: payoutData?.route || "IMPS",
    })
    console.log("payoutData", payoutData)
  }, [payoutData])



  const verifyBankAccount = () => {


    let error = {}

    if (isEmpty(fromData.accountNumber)) {
      error = { ...error, accountNumber: "Please enter account number" };
    }
    if (isEmpty(fromData.bankName)) {
      error = { ...error, bankName: "Please select bank" };
    }
    if (isEmpty(fromData.ifscCode)) {
      error = { ...error, ifscCode: "Please enter ifsc" };
    } else if (regifsc.test(fromData.ifscCode) != true) {
      error = { ...error, ifscCode: "Please enter the valid format of ifsc" };
    }

    setFromDataErr({ ...fromDataErr, ...error });

    if (!isEmpty(error)) return;


    const params = {
      accountNo: fromData.accountNumber || "",
      ifsc: fromData.ifscCode,
      bankId: fromData?.bankId,
      bankName: fromData.bankName,
      senderMobile: userName,
      lattitude: "24.034401",
      longitude: "24.034401",
      refferenceID: ""
    };


    setVerifyLoader(true);

    verifyAccount(params).then((resp) => {
      setVerifyLoader(false)
      console.log("success", resp)
      if (resp?.data.success) {
        setVerify(true);
        setVerifyResp(resp?.data?.data);
        setFromData({ ...fromData, "beneficiaryName": resp?.data?.data?.beneName });
        setMessage({ type: "success", msg: "Account verified successfully" })
      } else {
        let msg = resp?.data?.msg;
        if (!isEmpty(resp?.data?.errorCodeList)) {
          msg = resp?.data?.errorCodeList.toString()
        }
        setMessage({ type: "error", msg: msg })

      }
    }).catch(() => {
      setMessage({ type: "error", msg: "Something went wrong" })
      setVerifyLoader(false)
    })
  }

  const bankOptions = bankList?.map((val) => ({
    label: val.bankName,
    value: val.bankName,
  }))

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",

      minHeight: "40px",
      height: "40px",
      padding: "0 8px",
      boxShadow: "rgba(0, 41, 112, 0.15) 0px 1px 2px",
      borderRadius: "5px",
      backgroundColor: "#fff",
      fontSize: "12px",
      border: "1px solid transparent",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        border: "1px solid #ccc",
      },
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0",
    }),

    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),

    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),

    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),

    menu: (provided) => ({
      ...provided,
      fontSize: "12px",
      zIndex: 9999,
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      backgroundColor: state.isFocused ? "#f2f2f2" : "#fff",
      color: "#000",
      cursor: "pointer",
    }),
  };

  const paymentOptions = [
    { value: "DIOSM", label: "DPay" },
    { value: "MOBIFAST", label: "MPay" },
    { value: "INSTANT_PAY", label: "IPay" },
    { value: "ROUND_PAY", label: "RPay" },
    { value: "EKO", label: "EPay" },
    { value: "KVM", label: "KPay" },
    { value: "RAZORPAY", label: "Razorpay" },
    { value: "AXIS_BANK", label: "Axis Bank" },
  ];


  const commisionTypeOptions = [
    { value: "R", label: "₹" },
    { value: "P", label: "%" }
  ]

  const calculateSettlement = () => {
    let commissionAmount = 0;

    if (commisionType === "P") {
      // Percentage commission
      commissionAmount = (settlementData?.amount * commission) / 100;
    } else {

      // Flat commission
      commissionAmount = commission;

    }

    const settlementAmount = Number(settlementData?.amount) - commissionAmount;

    setCalData({
      commissionAmount,
      settlementAmount
    })
    setFromData({ ...fromData, "remittanceAmount": settlementAmount, remarks: "Settlement " + settlementData?.userFullName || "" });

  };



function scrollToError () {
  if (fromDataErr.beneficiaryName) {
    beneficiaryRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
  if (fromDataErr.accountNumber) {
    accountRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
  if (fromDataErr.ifscCode) {
    ifscRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
  if (fromDataErr.remittanceAmount) {
    amountRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
};
  return (
    <aside className={`aside-payout ${cls}`}>
      <div className="overlay" onClick={closeBox}></div>

      <div className="aside">
        {/* Header */}
        <div className="header">
          <h2>{type === "settlement" ? "Settlement" : "Payout"}</h2>
          <span className="close" onClick={closeBox}>×</span>
        </div>

        {/* Body */}
        <div className="body">
          {!isEmpty(message) && (
            <AlertWrapper className={`${message?.type} globle`}>
              <span className="close" style={{ top: "20px" }} onClick={() => setMessage({})}>
                ×
              </span>
              {
                message.type === "success" ?
                  <>
                    Account verified successfully
                    <div style={{ padding: "16px", margin: "4px", borderRadius: "8px", background: "#fff", width: "100%", minWidth: "260px" }}>
                      <p style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}><strong style={{ color: "#000" }}>Beneficiary Name:</strong> <span style={{ color: "#000" }}>{verifyResp?.beneName}</span></p>
                    </div>
                  </>
                  : message?.msg || "Something went wrong"
              }

            </AlertWrapper>
          )}
          {/* Section: Account */}
          <div className="section">
            <h4>Account Details</h4>

            <div className="input-field">
              <Select
                options={paymentOptions}
                value={paymentOptions?.find(
                  (opt) => opt.value === fromData?.mode
                )}
                styles={customStyles}
                onChange={(selected) =>
                  onchangeHandler({
                    target: { name: "mode", value: selected?.value },
                  })
                }
                placeholder="Select Debit Account"
              />
            </div>
          </div>

          {/* Section: Beneficiary */}
          <div className="section">
            <h4>Beneficiary</h4>

            <div className="mb-10">
              <input
              ref={beneficiaryRef}
                placeholder="Beneficiary Name"
                value={fromData?.beneficiaryName}
                onChange={onchangeHandler}
                name="beneficiaryName"
              />
              {fromDataErr.beneficiaryName && (
                <p className="error fs-12">
                  {fromDataErr.beneficiaryName}
                </p>
              )}
            </div>

            <div className="mb-10">
              <input
               ref={accountRef}
                placeholder="Account Number"
                value={fromData?.accountNumber}
                onChange={onchangeHandler}
                name="accountNumber"
              />
              {fromDataErr.accountNumber && (
                <p className="error fs-12 mt-10">
                  {fromDataErr.accountNumber}
                </p>
              )}
            </div>


            <div className="input-field" style={{ marginBottom: "10px" }}>
              <Select
                options={bankOptions}
                value={bankOptions?.find(
                  (opt) => opt.value === fromData?.bankName
                )}
                styles={customStyles}

                onChange={(selected) =>
                  onchangeHandler({
                    target: { name: "bankName", value: selected?.value },
                  })
                }
                placeholder="Select Bank(Optional)"
                isSearchable
              />
              {fromDataErr?.bankName && (
                <p className="error fs-12 mt-10">{fromDataErr?.bankName}</p>
              )}
            </div>
            <div className="row">
              <div className="mb-10" style={{ flex: "1" }}>
                <input
                ref={ifscRef}
                  placeholder="IFSC Code"
                  value={fromData?.ifscCode}
                  onChange={onchangeHandler}
                  name="ifscCode"
                />
                {fromDataErr.ifscCode && (
                  <p className="error fs-12 mt-10">{fromDataErr.ifscCode}</p>
                )}
              </div>

              {
                verify ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="30" viewBox="0 0 24 24" fill="#0f8f4f">
                    <circle cx="12" cy="12" r="10" fill="#0f8f4f" />
                    <path d="M8 12l3 3 5-6" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  :
                  <button className="calc-btn" disabled={verifyLoader} onClick={verifyBankAccount}>
                    {
                      verifyLoader ? <div className="VerifyLoader"> </div>
                        : <>Verify</>


                    }
                  </button>
              }

            </div>

          </div>

          {/* Section: Settlement */}
          {type === "settlement" && (
            <div className="section">
              <h4>Settlement</h4>

              <div className="mb-10">
                <input
                  disabled
                  value={settlementData?.amount}
                  placeholder="Transaction Amount"
                />
              </div>

              <div className="row">
                <Select
                  options={commisionTypeOptions}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null
                  }}
                  styles={customStyles}
                  value={commisionTypeOptions?.find(
                    (opt) => opt.value === commisionType
                  )}
                  onChange={(selected) => {
                    setCommisionType(selected?.value);
                    setCalData(null);
                  }}
                />

                <input
                  placeholder=" UPRR Commission"
                  value={commission || ""}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (!/^\d*\.?\d*$/.test(v)) return;
                    setCommission(v);
                    setCalData(null);
                  }}
                />

                <button className="calc-btn" onClick={calculateSettlement}>
                  Calculate
                </button>
              </div>

              {/* Result */}
              {calData && (
                <div className="result">
                  <div>
                    <span>Settlement</span>
                    <strong>₹{calData?.settlementAmount}</strong>
                  </div>
                  <div>
                    <span>UPRR Commission</span>
                    <strong>₹{calData?.commissionAmount}</strong>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Section: Amount */}
          <div className="section">
            <h4>{type === "settlement" ? "Settlement " : ""} Amount</h4>

            <div className="mb-10">
              <input
               ref={amountRef}
                placeholder="Enter Amount"
                value={fromData?.remittanceAmount}
                onChange={onchangeHandler}
                name="remittanceAmount"
                disabled={type === "settlement"}
              />
              {fromDataErr.remittanceAmount && (
                <p className="error fs-12 mt-10">
                  {fromDataErr.remittanceAmount}
                </p>
              )}
            </div>

            <p className="msg-text">
              {numberToWords(fromData?.remittanceAmount)}
            </p>

          </div>

          <div className="tabs">
            {["IMPS", "NEFT", "RTGS"].map((route) => (
              <button
                key={route}
                onClick={() => routeHandler(route)}
                className={`tab-btn ${fromData.route === route ? "active" : ""}`}
              >
                {route}
              </button>
            ))}
          </div>

          <p className="msg-text">
            Max ₹5 lakh per transaction. Real-time credit. Works 24×7.
          </p>

          <div className="section" style={{ marginTop: "10px" }}>
            <h4>Remark</h4>

            <div className="mb-10">
              <input
                type="text"
                id="remarks"
                name="remarks"
                value={fromData?.remarks.trim()}
                onChange={onchangeHandler}
                placeholder="Remarks(optional)"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer">
          <button
            className="primary-btn"
            onClick={onSubmit}
            disabled={(type === "settlement" && !calData) || loding}
          >
            {!loding ? "Proceed" : <Spinner />}
          </button>
        </div>
      </div>
      {!isEmpty(responceData) && (
        <Receipt modalData={responceData} onCloseModal={onCloseModal} />
      )}
    </aside>
  );
}

export default AsideLeft_V2;
